import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M2 7h20V5H2v2zm17 6H5v-2h14v2zm-3 6H8v-2h8v2z" }));
export default createSvgIcon(iconPath, "Filter");
//# sourceMappingURL=FilterIcon.js.map